export enum ENCRYPTION_TYPE {
	PLAIN = 0,
	ENCRYPTED = 1
}
